import React from 'react';
import { ShieldCheckIcon, ClipboardCheckIcon, HomeIcon } from 'lucide-react';
const Hero = () => {
  return <section className="bg-gradient-to-r from-blue-600 to-blue-800 text-white" data-id="element-231">
      <div className="container mx-auto px-4 py-16 md:py-24" data-id="element-232">
        <div className="grid md:grid-cols-2 gap-10 items-center" data-id="element-233">
          <div data-id="element-234">
            <h1 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-235">
              EICR Certificates for{' '}
              <span className="text-yellow-300" data-id="element-236">Safe</span> Properties
            </h1>
            <p className="text-lg md:text-xl mb-8 text-blue-100" data-id="element-237">
              Professional Electrical Installation Condition Reports by
              certified electricians across the UK. Ensure your property meets
              the latest safety regulations.
            </p>
            <div className="flex flex-col sm:flex-row gap-4" data-id="element-238">
              <a href="#contact" className="bg-yellow-500 hover:bg-yellow-600 text-blue-900 font-semibold px-8 py-3 rounded-md text-center transition-colors" data-id="element-239">
                Book an Inspection
              </a>
              <a href="#pricing" className="bg-white hover:bg-blue-100 text-blue-800 font-semibold px-8 py-3 rounded-md text-center transition-colors" data-id="element-240">
                View Pricing
              </a>
            </div>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-lg" data-id="element-241">
            <h2 className="text-blue-800 text-xl font-bold mb-4" data-id="element-242">
              Why Choose Our EICR Service?
            </h2>
            <ul className="space-y-4 text-gray-700" data-id="element-243">
              <li className="flex items-start" data-id="element-244">
                <ShieldCheckIcon className="w-6 h-6 mr-3 text-blue-600 flex-shrink-0" data-id="element-245" />
                <span data-id="element-246">
                  Fully compliant with the latest UK electrical safety
                  regulations
                </span>
              </li>
              <li className="flex items-start" data-id="element-247">
                <ClipboardCheckIcon className="w-6 h-6 mr-3 text-blue-600 flex-shrink-0" data-id="element-248" />
                <span data-id="element-249">Same-day certificates for urgent requirements</span>
              </li>
              <li className="flex items-start" data-id="element-250">
                <HomeIcon className="w-6 h-6 mr-3 text-blue-600 flex-shrink-0" data-id="element-251" />
                <span data-id="element-252">
                  Suitable for landlords, homeowners, and commercial properties
                </span>
              </li>
            </ul>
            <div className="mt-6 p-4 bg-blue-50 rounded-md" data-id="element-253">
              <p className="text-blue-800 font-medium text-center" data-id="element-254">
                Landlords: Meet your legal obligations with our fast and
                reliable EICR service
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default Hero;